import React, { FC, ReactNode } from 'react';

type InlineNavCellProps = {
  row: number;
  col: string;
  children: ReactNode;
};

export const InlineNavCell: FC<InlineNavCellProps> = ({
  row,
  col,
  children,
}) => (
  <div data-pt-nav-cell data-pt-row={row} data-pt-col={col}>
    {children}
  </div>
);
